import gql from 'graphql-tag';

const GET_QUOTE = gql`
  query getQuote(
    $input: QuoteIdentifierInput!
    $isTaxSplitEnabled: Boolean!
    $clientCustomFields: [String!]
  ) {
    getQuote(input: $input) {
      quoteId
      displayId
      quoteDate
      expiryDate
      statusEnum
      approverName
      customFields
      items {
        itemId
        itemOrder
        discountType
        discountAmount
        serviceItem {
          itemId
          name
          invoiceDescription
          quantityType
          roundUpValue
          unitPrice
          category {
            categoryId
            name
          }
          businessHoursUnitPrice
          afterHoursUnitPrice
          useAsWorklogItem
          quantity
        }
        serviceCatalogItem {
          itemId
          name
          itemType
          category {
            categoryId
            name
          }
          offerAsWorklogItem
          # sellingPrice {
          #   details {
          #     value
          #     afterHoursValue
          #   }
          # }
          serviceTypeItem {
            itemId
            offeringType
            hourlyServiceTypeItem {
              itemId
              roundUpValue
              defaultItem
            }
            redeemableServiceBundle {
              itemId
              redeemableQuantity
              applicableHours
            }
          }
        }
        discountRate
        details
        quantity
        unitPrice
        amount
        taxable
        tax {
          taxId
          name
          rates {
            rateId
            name
            rateValue
          }
        }
      }
      client {
        accountId
        name
        logoFileName
        customFields(fields: $clientCustomFields)
      }
      site {
        id
        name
        line1
        line2
        line3
        countryCode
        stateCode
        city
        postalCode
      }
      senderAddress
      billingAddress
      discountAmount
      taxes {
        tax {
          taxId
          name
          rates {
            rateId
            name
            rateValue
          }
        }
        rate @include(if: $isTaxSplitEnabled) {
          rateId
          name
          rateValue
        }
        taxRate
        taxableAmount
        taxAmount
      }
      taxAmount
      totalAmount
      additionalDiscount
      additionalDiscountRate
      additionalDiscountType
      description
      title
      footer
      memo
      invoice {
        invoiceId
        displayId
      }
      createdTime
    }
  }
`;

const GET_QUOTE_VERSIONS = gql`
  query getQuoteVersions(
    $input: QuoteIdentifierInput!
    $isTaxSplitEnabled: Boolean!
  ) {
    getQuoteVersions(input: $input) {
      senderAddress
      billingAddress
      quoteId
      displayId
      quoteDate
      expiryDate
      statusEnum
      customFields
      items {
        itemId
        itemOrder
        serviceCatalogItem {
          itemId
          name
        }
        serviceItem {
          itemId
          name
          invoiceDescription
          quantityType
          roundUpValue
          unitPrice
          category {
            categoryId
            name
          }
          businessHoursUnitPrice
          afterHoursUnitPrice
          useAsWorklogItem
          quantity
        }
        discountRate
        details
        quantity
        unitPrice
        amount
        taxable
        tax {
          taxId
          name
          rates {
            rateId
            name
            rateValue
          }
        }
      }
      client {
        accountId
        name
        logoFileName
      }
      site {
        id
        name
        line1
        line2
        line3
        countryCode
        stateCode
        city
        postalCode
      }
      discountAmount
      taxes {
        tax {
          taxId
          name
          rates {
            rateId
            name
            rateValue
          }
        }
        taxRate
        taxableAmount
        taxAmount
        rate @include(if: $isTaxSplitEnabled) {
          rateId
          name
          rateValue
        }
      }
      taxAmount
      totalAmount
      additionalDiscount
      additionalDiscountRate
      description
      title
      footer
      memo
      invoice {
        invoiceId
      }
      createdTime
    }
  }
`;

const GET_QUOTE_EVENTS = gql`
  query getQuoteEvents($input: GetQuoteEventsInput!) {
    getQuoteEvents(input: $input) {
      events {
        conversation {
          parentConversationId
          conversationId
          content
          subject
          time
          viewedByClient
          attachments {
            fileName
            fileSize
            originalFileName
          }
          user {
            name
            email
            userId
          }
          toUsers {
            user {
              userId
              email
              name
            }
          }
          ccUsers {
            user {
              userId
              email
              name
            }
          }
          bccUsers {
            user {
              userId
              email
              name
            }
          }
        }
        approval {
          approvalId
          status
          comment
          approver {
            userId
            name
            email
          }
        }
        eventType
        createdTime
      }
      listInfo {
        page
        pageSize
        totalCount
      }
    }
  }
`;

const GET_CONTENT_FOR_SEND_QUOTE = gql`
  query getContentForSendQuote($input: QuoteIdentifierInput!) {
    getContentForSendQuote(input: $input) {
      conversationId
      content
      subject
      attachments {
        fileName
        originalFileName
        fileSize
      }
      toUsers {
        user {
          userId
          email
          name
        }
      }
      ccUsers {
        user {
          userId
          email
          name
        }
      }
      bccUsers {
        user {
          userId
          email
          name
        }
      }
    }
  }
`;

const GET_QUOTE_CONFIG = gql`
  query {
    getQuoteConfiguration {
      layoutConfiguration
      preferences
    }
  }
`;

const GET_QUOTE_ADDRESS = gql`
  query getQuoteAddress($input: GetBillingAddressInput) {
    getQuoteAddress(input: $input) {
      sender
      billing
    }
  }
`;

export {
  GET_QUOTE,
  GET_QUOTE_CONFIG,
  GET_QUOTE_VERSIONS,
  GET_QUOTE_EVENTS,
  GET_CONTENT_FOR_SEND_QUOTE,
  GET_QUOTE_ADDRESS
};
